import styled from "styled-components"

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`
